import { render } from "./TvmServiceOffers.vue?vue&type=template&id=1ac9f0ec&scoped=true"
import script from "./TvmServiceOffers.js?vue&type=script&lang=js&external"
export * from "./TvmServiceOffers.js?vue&type=script&lang=js&external"

import "./TvmServiceOffers.vue?vue&type=style&index=0&id=1ac9f0ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac9f0ec"],['__file',"src/components/ChatWidget/TvmServiceOffers/TvmServiceOffers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ac9f0ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ac9f0ec', __exports__)) {
    api.reload('1ac9f0ec', __exports__)
  }
  
  module.hot.accept("./TvmServiceOffers.vue?vue&type=template&id=1ac9f0ec&scoped=true", () => {
    api.rerender('1ac9f0ec', render)
  })

}


export default __exports__